

<div class="container-fluid" style="background-color: white;background-image: url(../../../../assets/img/school/navbar.png);">
    <div class="row align-items-center justify-content-center bgImage">
        <div class="col-12 col-lg-3 col-md-12 text-center">
           <div *ngIf="isBig">
             <ul class="topbar-social-links">
                <li><ng-container *ngIf="mainData != null"><a class="navbar-brand" routerLink="/">
                            <div class="image-container" style="padding-left: 60px;padding-bottom: 20px;">
                                <!-- <img [src]="mainData.LogoUrl" alt="logo" class="custom-image" /> -->
                                 <img [src]="mainData.LogoUrl"  alt="" style="height: 135px;width: 135px;">
                            </div>
                        </a></ng-container>

                </li>
            </ul>
           </div>
            <div *ngIf="isSmall">
             <ul class="topbar-social-links">
                <li>
                    <!-- <ng-container *ngIf="mainData != null"><a class="navbar-brand" routerLink="/">
                            <div class="image-container" style="padding-left: 25px;padding-bottom: 20px;">
                                
                                 <img [src]="mainData.LogoUrl"  alt="" style="height: 148px;width: 100px;">
                            </div>
                        </a></ng-container> -->

                </li>
            </ul>
           </div>
        </div>
        <div class="col-12 col-lg-6 col-md-12 text-center">
            <ul class="topbar-action-list text-center">
                <h3 class="header-arabic">المدرسة الأحمدية الطيبية السنية الدخيل
                    
                </h3>
                <h2 class="header-bangla">আহমদিয়া তৈয়্যবিয়া সুন্নিয়া দাখিল মাদরাসা
                </h2>
                <h2 class="header-english">Ahmadia Tayabia Sunnia Dakhil Madrasah</h2>
                <h4 class="header-address">ছোট মহেশখালী,মহেশখালী, কক্সবাজার,চট্টগ্রাম</h4>
                <!-- <h5 style="font-family: 'Congenial'; font-size: 1rem;color: #026670;">EIIN: 107902 |  Madrasah Code: 16823 </h5> -->
                <br>
            </ul>
        </div>
        <div class="col-12 col-lg-3 col-md-12 text-center">
             <div *ngIf="isBig">
            <ul class="topbar-action-list" style="font-family: 'Li Ador Noirrit SemiBold';padding-bottom: 10px;">
                                                 <img src="../../../../assets/img/school/header right top logo.png"  alt="" style="height: 135px;width: 135px;">
             


















                          














































              
            </ul>
            </div>
        </div>
    </div>
</div>


<div class="navbar-area navbar-area-with-position-relative">
    <div class="karlson-nav">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="d-lg-none">
                    <a class="navbar-brand d-" routerLink="/">
                        <img src="assets/img/school/logo.png" alt="logo" class="logo">
                    </a>
                </div>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                 <div class="d-lg-none">

                 <ul class="topbar-action-list" style="font-family: 'Li Ador Noirrit SemiBold';">
                                                 <img src="../../../../assets/img/school/header right top logo.png"  alt="" class="logo">
            </ul>
                 </div>
             
                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent" *ngIf="isBig">
                    <ul class="navbar-nav" style="font-family: 'Li Ador Noirrit SemiBold' !important;">
                        <li class="nav-item">
                            <a routerLink="/" routerLinkActive="active" class="nav-link buttonContent buttonCenter"
                                style="padding-right:15px ;padding-top: 0px;color: white;font-size: 15px;">হোম</a>
                        </li>

                        <ng-container *ngFor="let items of  AllmenuItems">
                                <li class="nav-item dropdown" >
                                    <a class="nav-link dropdown-toggle"style="color: white;font-size: 15px;" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        🔆 {{ items.DisplayNameBangla }}
                                    </a>
                                    <ul class="dropdown-menu">
                                        <ng-container *ngFor="let item of items.Items">
                                            <li class="nav-item" data-toggle="collapse"
                                                data-target=".navbar-collapse.show">
                                                <a [routerLink]="item.MenuUrl" routerLinkActive="active"
                                                    [routerLinkActiveOptions]="{
                                                        exact: true
                                                    }" class="nav-link"><span style="flex-shrink: 0;">🔸</span><span>{{ item.DisplayNameBangla }}</span></a>

                                            </li>
                                        </ng-container>
                                    </ul>
                                </li>
                            </ng-container>
                    </ul>
                </div>
                <div class="collapse navbar-collapse mean-menu-new" id="navbarSupportedContent" *ngIf="isSmall"
                    style="padding: 0;">
                    <ul class="navbar-nav" style="font-family: 'Li Ador Noirrit SemiBold' !important;">
                        <li class="nav-item">
                            <a routerLink="/" routerLinkActive="active"
                                class="nav-link buttonContent buttonCenter">হোম</a>
                        </li>
                        <ng-container *ngFor="let items of  AllmenuItems">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        🔆 {{ items.DisplayNameBangla }}
                                    </a>
                                    <ul class="dropdown-menu">
                                        <ng-container *ngFor="let item of items.Items">
                                            <li class="nav-item" data-toggle="collapse"
                                                data-target=".navbar-collapse.show">
                                                <a [routerLink]="item.MenuUrl" routerLinkActive="active"
                                                    [routerLinkActiveOptions]="{
                                                        exact: true
                                                    }" class="nav-link"><span style="flex-shrink: 0;">🔸</span><span>{{ item.DisplayNameBangla }}</span></a>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </li>
                            </ng-container>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>